var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2223 18.6665H25.5556C27.7648 18.6665 29.5556 20.4573 29.5556 22.6665C29.5556 24.8756 27.7648 26.6665 25.5556 26.6665H12.2223C10.0132 26.6665 8.22229 24.8756 8.22229 22.6665C8.22229 20.4573 10.0132 18.6665 12.2223 18.6665ZM36.2223 39.9998H49.5556C51.7648 39.9998 53.5556 41.7907 53.5556 43.9998C53.5556 46.2089 51.7648 47.9998 49.5556 47.9998H36.2223C34.0131 47.9998 32.2223 46.2089 32.2223 43.9998C32.2223 41.7907 34.0131 39.9998 36.2223 39.9998Z",
    fill: "#EBA183"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5556 29.3336C41.1373 29.3336 37.5556 25.7518 37.5556 21.3336C37.5556 16.9153 41.1373 13.3336 45.5556 13.3336C49.9739 13.3336 53.5556 16.9153 53.5556 21.3336C53.5556 25.7518 49.9739 29.3336 45.5556 29.3336ZM16.2223 50.6669C11.804 50.6669 8.22229 47.0852 8.22229 42.6669C8.22229 38.2486 11.804 34.6669 16.2223 34.6669C20.6406 34.6669 24.2223 38.2486 24.2223 42.6669C24.2223 47.0852 20.6406 50.6669 16.2223 50.6669Z",
    fill: "#EBA183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreSingle);
export default __webpack_public_path__ + "static/media/core_single.b4019cdcd9fd80d0c4916243b5693716.svg";
export { ForwardRef as ReactComponent };